function cleanPlayerName(name, joinChar, capitalize) {
  name = name
    .replace(/'/g, '')
    .replace(/\./g, '')
    .replace(/'/g, "''")
    .replace(/¡/g, 'i')
    .replace(/¢/g, '')
    .replace(/£/g, '')
    .replace(/¤/g, '')
    .replace(/¥/g, '')
    .replace(/¦/g, '')
    .replace(/§/g, '')
    .replace(/¨/g, '')
    .replace(/©/g, '')
    .replace(/ª/g, '')
    .replace(/«/g, '')
    .replace(/¬/g, '')
    .replace(/­/g, '')
    .replace(/¯/g, '')
    .replace(/°/g, '')
    .replace(/²/g, '')
    .replace(/³/g, '')
    .replace(/´/g, '')
    .replace(/µ/g, '')
    .replace(/¶/g, '')
    .replace(/·/g, '')
    .replace(/¸/g, '')
    .replace(/¹/g, '')
    .replace(/º/g, '')
    .replace(/»/g, '')
    .replace(/¼/g, '')
    .replace(/½/g, '')
    .replace(/¾/g, '')
    .replace(/¿/g, '')
    .replace(/À/g, 'a')
    .replace(/Á/g, 'a')
    .replace(/Â/g, 'a')
    .replace(/Ã/g, 'a')
    .replace(/Ä/g, 'a')
    .replace(/Ã¹/g, 'ù')
    .replace(/Å/g, 'a')
    .replace(/Æ/g, 'a')
    .replace(/Ç/g, 'c')
    .replace(/È/g, 'e')
    .replace(/É/g, 'e')
    .replace(/Ê/g, 'e')
    .replace(/Ë/g, 'e')
    .replace(/Ì/g, 'i')
    .replace(/Í/g, 'i')
    .replace(/Î/g, 'i')
    .replace(/Ï/g, 'i')
    .replace(/Ð/g, 'd')
    .replace(/Ñ/g, 'n')
    .replace(/Ò/g, 'o')
    .replace(/Ó/g, 'o')
    .replace(/Ô/g, 'o')
    .replace(/Õ/g, 'o')
    .replace(/Ö/g, 'o')
    .replace(/×/g, 'x')
    .replace(/Ø/g, '0')
    .replace(/Ù/g, 'u')
    .replace(/Ú/g, 'u')
    .replace(/Û/g, 'u')
    .replace(/Ü/g, 'u')
    .replace(/Ý/g, 'y')
    .replace(/Þ/g, 'p')
    .replace(/ß/g, 'b')
    .replace(/à/g, 'a')
    .replace(/á/g, 'a')
    .replace(/â/g, 'a')
    .replace(/ã/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/å/g, 'a')
    .replace(/æ/g, 'a')
    .replace(/ç/g, 'c')
    .replace(/è/g, 'e')
    .replace(/é/g, 'e')
    .replace(/ê/g, 'e')
    .replace(/ë/g, 'e')
    .replace(/ì/g, 'i')
    .replace(/í/g, 'i')
    .replace(/î/g, 'i')
    .replace(/ï/g, 'i')
    .replace(/ð/g, 'o')
    .replace(/ñ/g, 'n')
    .replace(/ò/g, 'o')
    .replace(/ó/g, 'o')
    .replace(/ô/g, 'o')
    .replace(/õ/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/÷/g, '')
    .replace(/ø/g, 'o')
    .replace(/ù/g, 'u')
    .replace(/ú/g, 'u')
    .replace(/û/g, 'u')
    .replace(/ü/g, 'u')
    .replace(/ý/g, 'y')
    .replace(/þ/g, 'b')
    .replace(/ÿ/g, 'y')
    .split(' ')
    .join(joinChar);
  if (capitalize) {
    return name;
  }
  return name.toLowerCase();
}

export { cleanPlayerName };



// WEBPACK FOOTER //
// ./src/utils/cleanString.js